/**
 * =====================================
 * Searchable service
 *  ====================================
 *
 * Search actions in the API.
 * Imported by APIs.
 *
 * =====================================
 */
export default {
  /**
   * Search for a specific resource in the database.
   *
   */
  search (params) {
    return this.http(this.baseUrl)
      .get(`${this.url}/search`, { params })
  },

  /**
   * Strictly search for a specific resource in the database.
   *
   */
  searchStrict (payload) {
    return this.http(this.baseUrl)
      .post(`${this.url}/search-strict`, payload)
  },

  /**
   * Search for a specific resource in the database.
   *
   */
  searchUnitCost (params) {
    return this.http(this.baseUrl)
      .get(`${this.url}/search-unit-cost`, { params })
  },
}
